import { Env } from "./env.js";
import { Urlparam } from "./urlparam.js"; // URLパラメータ
import { Swp } from "./swp.js"; //Swiper

export class Opening {
  constructor() {
    this.body = {};
    this.html = {};
    this.env = {};
    this.paramAncher = {};
    this.stopflg = false; //loadingで止める

    // loading
    this.loadingStartTime = 0;
    this.minLoadingTime = 2000;
    this.loadingWaitTime = 0;
  }

  init() {
    this.body = document.getElementsByTagName("body")[0];
    this.html = document.getElementsByTagName("html")[0];

    // 環境
    this.env = new Env();
    this.env.detectEnv();

    // URLパラメータ
    this.paramAncher = new Urlparam();
    this.paramAncher.getParam("op", location.href);
    if (
      this.paramAncher.param == 0 ||
      document.getElementById("index-loading") == null
    ) {
      // Openingなし
      window.setTimeout(() => {
        this.body.classList.add("opening-skipped");
        this.body.classList.add("opening-start");
        this.body.classList.add("opening-finished");
      }, 1);
      window.setTimeout(() => {
        this.body.classList.remove("opening-skipped");
      }, 200);
    } else if (this.paramAncher.param == 9) {
      this.stopflg = true;
    } else {
      //this.flg = true;
    }
  }

  // ローディング表示終了
  finishedLoading() {
    this.body.classList.add("opening-start");

    // Swiper
    this.sliders = new Swp();
    this.sliders.init();

    window.setTimeout(() => {
      this.body.classList.add("show-menu");
    }, 500);
    window.setTimeout(() => {
      this.body.classList.add("opening-finished");
    }, 1800);
  }

  // ローディングを一定時間は必ず表示
  startLoading() {
    if (!this.stopflg) {
      window.setTimeout(() => {
        this.finishedLoading();
      }, this.minLoadingTime);
    }
  }
}
